
import NoticeList from '@/views/notice/NoticeList'
import NoticeDetail from '@/views/notice/NoticeDetail'

export default [


    {
        path: '/notice',
        name: 'notice-list',
        component: NoticeList,
        meta: {
            auth: true,
            logging: true, 
            pageName: '공지사항 목록' 
        }
    },
    {
        path: '/notice/detail',
        name: 'notice-detail',
        component: NoticeDetail,
        meta: {
            auth: true,
            logging: true, 
            pageName: '공지사항 상세' 
        }
    }
]